import { render, staticRenderFns } from "./StudyIndividual.vue?vue&type=template&id=e9d0cdaa&scoped=true&lang=pug"
import script from "./StudyIndividual.vue?vue&type=script&lang=ts"
export * from "./StudyIndividual.vue?vue&type=script&lang=ts"
import style0 from "./StudyIndividual.vue?vue&type=style&index=0&id=e9d0cdaa&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d0cdaa",
  null
  
)

export default component.exports